export const MULTIPLE = 'multiple'
export const ONCE = 'once'
